import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  CardHeader,
  ButtonGroup,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { Column } from 'primereact/column';
import {
  Delete,
  InputText,
  InputDate,
  TableReducer,
} from '@components/form';
import HorizontalLayout from "@components/layout/HorizontalClean";

import ProrrogarTesteModal from './modal/ProrrogarTesteModal';

import { PageLoaderScreen } from '@components/common/PageLoaderScreen';
import { Formik, Form } from 'formik'
import * as Yup from 'yup';

import {
  FIND_CONTA_AGRARE,
  HAS_AUTHORITY_CORPORATE,
  NEW_FILTER_CONTA_AGRARE,
  NEW_FILTER_NEXT_PAGE_CONTA_AGRARE,
  SELECT_FAZENDA,
  TABLE_PROPRIEDADE_CADASTRO,
  CONFIG_SESSION,
  DELETE_CONTA_AGRARE,
  BLOQUEAR_CONTA_AGRARE,
  PRORROGAR_TESTE_CONTA_AGRARE,
  DESBLOQUEAR_CONTA_AGRARE,
} from '@handler';
import { formatCheck, formatDateDDMMYYYY } from '@components/common/format';
import { getTipoAtividadeAgricolaDescricaoById, TIPO_CLIENTE_AGRARE_ATIVIDADE_AGRICOLA_ENUM } from '@handler/contaAgrare/tipoClienteAgrareAtividadeAgricolaEnum';
import { getTipoLocalTrabalhoDescricaoById } from '@handler/contaAgrare/tipoClienteAgrareLocalTrabalhoEnum';
import { SelectEnum } from '@components/search/enumSelect';
import { TIPO_SIM_NAO_ENUM } from '@handler/common/enums/tipoSimNaoEnum';
import { OBJETIVO_PRODUTOR_ENUM } from "@handler/common/onBoarding/objetivoProdutorEnum";
import BreadcrumbOnFarmCorporate from '@components/common/BreadcrumbOnFarmCorporate';
import { SelectGrupoContaAgrareWhiteLabel } from '@components/search/intranetWhiteLabel/grupoContaAgrareWl';

import { storage } from '@commons';
import { COMO_CONHECEU_AGRARE_ENUM } from '@handler/login/comoConheceuAgrareEnum';

class ContaAgrare extends React.Component {

  state = {
    keyDatable: 1,
    openDropdownId: null,
    showFullFilters: false,
    prorrogarTesteModal: {
      isOpen: false,
      contaId: null,
      nomeConta: '',
      dataAtual: '',
    }
  }

  async componentDidMount() {
    await this.props.hasAuthorityCorporate('PERM_ROLE_WL_REGISTER_FARMER');
    await this.props.filter(false);
  }
  
  componentDidUpdate(prevProps) {
    if (!this.state.showFullFilters && this.props.contaAgrareReducer.list !== null) {
      this.setState({ showFullFilters: true });
    }
  }

  toggleFullFilters = () => {
    this.setState((prevState) => ({ showFullFilters: !prevState.showFullFilters }));
  };

  remove = async (registro) => {
    await this.props.deleteContaAgrare(registro.id);
  }

  onSearch = async (values, handleSubmit, isValid) => {
    handleSubmit()
    if (isValid) {
      await this.props.filter(true, values);
      this.setState({ keyDatable: this.state.keyDatable + 1 })
    }
  }

  toggleDropdown = (id) => {
    this.setState(prevState => ({
      openDropdownId: prevState.openDropdownId === id ? null : id
    }));
  }

  toggleProrrogarTesteModal = (rowData = null) => {
    if (rowData) {
      this.setState({
        prorrogarTesteModal: {
          isOpen: true,
          contaId: rowData.id,
          nomeConta: rowData.nomeConta,
          dataAtual: formatDateDDMMYYYY(rowData.licenca.dataFimPeriodoTeste)
        }
      });
    } else {
      this.setState({
        prorrogarTesteModal: {
          isOpen: false,
          contaId: null,
          nomeConta: '',
          dataAtual: ''
        }
      });
    }
  }

  handleProrrogarTeste = (data) => {
    this.props.prorrogarTesteContaAgrare(data);
  }

  render() {
    const { contaAgrareReducer, loginReducer } = this.props;
    const { prorrogarTesteModal } = this.state;

    function renderColumnAtivo(value) {
      if (value.licenca.bloqueado ) {
        return <span className={`badge badge-dark`} style={{ fontSize: '12px' }}>Bloqueado</span>;
      }

      return formatCheck(value.status);
    };

    function renderColumnIsTesting(value) {
      return formatCheck(value.licenca.licencaEmTeste);
    };
    
    function renderAtividadeAgricola(value) {
      return getTipoAtividadeAgricolaDescricaoById(value.atividadeAgricola);
    }

    function renderLocalTrabalho(value) {
      return getTipoLocalTrabalhoDescricaoById(value.localTrabalho);
    }

    function renderColumnObjetivo(value) {
      const objetivo = OBJETIVO_PRODUTOR_ENUM.find(item => item.id === value.objetivoProdutor);
      if (objetivo?.id === 'OUTRO') {
        return (
          <div>
            {objetivo.descricao}<br />
            <div style={{ fontSize: '12px', fontStyle: 'italic' }}>({value.outroObjetivoProdutor})</div>
          </div>
        );
      }
      return objetivo ? objetivo.descricao : value.objetivoProdutor;
    }

    function renderColumnComoConheceu(value) {
      const comoConheceu = COMO_CONHECEU_AGRARE_ENUM.find(item => item.id === value.comoConheceuAgrare);
      if (comoConheceu?.id === 'OTHER') {
        return (
          <div>
            {comoConheceu.descricao}<br />
            <div style={{ fontSize: '12px', fontStyle: 'italic' }}>({value.outroComoConheceuAgrare})</div>
          </div>
        );
      }
      return comoConheceu ? comoConheceu.descricao : value.comoConheceuAgrare;
    }

    function renderColumnNroProrrogacoesTeste(value) {
      if (value.nroProrrogacoesTeste) return value.nroProrrogacoesTeste;
      return 0;
    }

    function renderColumnDataCadastro(value) {
      return formatDateDDMMYYYY(value.licenca.dataCadastro);
    }

    function renderColumnDataFimPeriodoTeste(value) {
      return formatDateDDMMYYYY(value.licenca.dataFimPeriodoTeste);
    }

    function renderColumnDataUltimoAcesso(value) {
      if (value.dataUltimoAcesso)
        return formatDateDDMMYYYY(value.dataUltimoAcesso);
      return '';
    }

    function renderColumnDataBloqueio(value) {
      if (value.licenca.dataBloqueio)
        return formatDateDDMMYYYY(value.licenca.dataBloqueio);
      return '';
    }

    function renderColumnDataRenovacao(value) {
      return '';
      // return formatDateDDMMYYYY(value.dataRenovacao);
    }

    function renderNomeConta(value) {
      return (
        <div>
          {value.nomeConta}<br />
          <div style={{ fontSize: '12px', fontStyle: 'italic' }}>({value.clienteAgrareGrupo?.nome})</div>
        </div>
      );
    };

    return (
      <HorizontalLayout>
        <PageLoaderScreen loading={contaAgrareReducer.loading || this.props.propriedadeCadastroReducer.loading} />

        {/* Modals */}
        <ProrrogarTesteModal 
          isOpen={prorrogarTesteModal.isOpen}
          toggle={() => this.toggleProrrogarTesteModal()}
          contaId={prorrogarTesteModal.contaId}
          nomeConta={prorrogarTesteModal.nomeConta}
          dataAtual={prorrogarTesteModal.dataAtual}
          onSubmit={this.handleProrrogarTeste}
        />

        <div className="container-fluid">
          <Row className="align-items-center">
            <Col sm={12}>
              <div className="page-title-box">
                <h4 className="font-size-18">Cadastro de Conta Produtor</h4>
                <BreadcrumbOnFarmCorporate>
                  <React.Fragment>
                    <li className="breadcrumb-item">
                      <Link to="#">On Farm Coporate</Link>
                    </li>
                    <li className="breadcrumb-item active">Conta Produtor</li>
                  </React.Fragment>
                </BreadcrumbOnFarmCorporate>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Card className='card-default'>
                <CardBody>
                  <Row>
                    <Col md={12}>
                      {/* <Link to='/corporate/contaProdutor/novo' title='Adicionar Nova Conta'> */}
                        <Button className="btn-primary" disabled onClick={() => { }}>
                          <i className='fas fa-plus' /> Adicionar Nova Conta
                        </Button>
                      {/* </Link> */}
                    </Col>
                  </Row>

                  <br />

                  <CardHeader className="filter-box">
                    <Row className="mb-2 align-items-center">
                      <Col xs={12} md={6} className="d-flex align-items-center mb-2 mb-md-0">
                        <i className="fas fa-filter text-primary mr-2"></i>
                        <h5 className="mb-0 text-primary font-weight-bold">Filtros de Pesquisa</h5>
                      </Col>
                      <Col xs={12} md={6} className="d-flex justify-content-md-end">
                        <Button className="w-100 w-md-auto" size="sm" color="secondary" onClick={this.toggleFullFilters}>
                          <i className="fas fa-sliders-h"></i> {this.state.showFullFilters ? "Filtro Resumido" : "Filtro Completo"}
                        </Button>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <Formik
                          enableReinitialize
                          initialValues={contaAgrareReducer.filter}
                          validationSchema={Yup.object().shape({
                            status: Yup.string()
                              .typeError('Este campo é obrigatório')
                              .required('Este campo é obrigatório'),
                          })}
                          onSubmit={() => { }}
                        >
                          {({ errors, touched, values, isValid, handleSubmit }) => (
                            <Form id='filterForm' >
                              {/* Filtro Resumido */}
                              <Row>
                                <SelectEnum
                                  name='status'
                                  label='Conta Ativa'
                                  placeholder='Status Conta'
                                  list={TIPO_SIM_NAO_ENUM}
                                  col={this.state.showFullFilters === true ? 3 : 2}
                                />
                                <SelectEnum
                                  name='licencaEmTeste'
                                  label='Em Teste'
                                  placeholder='Selecione'
                                  list={TIPO_SIM_NAO_ENUM}
                                  col={this.state.showFullFilters === true ? 3 : 2}
                                />
                                <InputText
                                  name='nomeConta'
                                  label='Nome da Conta'
                                  placeholder='Pesquise pelo nome da conta'
                                  col={6}
                                />
                                {this.state.showFullFilters === false ? (
                                  <Col md={2}>
                                    <ButtonGroup style={{ marginTop: '15px' }}>
                                      <Button color="primary"
                                        onClick={() => { this.onSearch(values, handleSubmit, isValid) }}
                                      >
                                        <i className='fa fa-refresh' /> Atualizar</Button>
                                    </ButtonGroup>
                                  </Col>
                                 ) : <></>}
                              </Row>

                              {/* Filtro Completo */}
                              {this.state.showFullFilters && (
                                <>
                                  <Row>
                                    <InputText
                                      name='accountCode'
                                      label='Código da Conta'
                                      placeholder='Pesquise pelo código da Conta'
                                      col={3}
                                    />
                                    <SelectEnum
                                      name='atividadeAgricola'
                                      label='Principal Atividade Agrícola'
                                      placeholder='Principal Atividade Agrícola'
                                      list={TIPO_CLIENTE_AGRARE_ATIVIDADE_AGRICOLA_ENUM}
                                      col={3}
                                    />
                                    <SelectEnum
                                      name='objetivoProdutor'
                                      label='Desafio Produtor'
                                      placeholder='Selecione'
                                      list={OBJETIVO_PRODUTOR_ENUM}
                                      col={6}
                                    />
                                  </Row>
                                  <Row>
                                    <InputText
                                      name='nomeResponsavelConta'
                                      label='Nome do Reponsável da Conta'
                                      placeholder='Pesquise pelo nome do responsável da conta'
                                      col={6}
                                    />
                                    <InputText
                                      name='emailPrincipal'
                                      label='Email do Reponsável da Conta'
                                      placeholder='Pesquise pelo email do responsável da conta'
                                      col={6}
                                    />
                                  </Row>
                                  <Row>
                                    <InputDate name='dataCriacaoInicial'
                                      label={'Data Criação - Inicial'}
                                      col={3}
                                    />
                                    <InputDate name='dataCriacaoFinal'
                                      label={'Data Criação - Final'}
                                      col={3}
                                    />
                                    <InputDate name='dataFimTesteInicial'
                                      label={'Data Fim do Teste - Inicial'}
                                      col={3}
                                    />
                                    <InputDate name='dataFimTesteFinal'
                                      label={'Data Fim do Teste - Final'}
                                      col={3}
                                    />
                                  </Row>
                                  <Row>
                                    <InputDate name='dataUltAcessoInicial'
                                      label={'Data Último Acesso - Inicial'}
                                      col={3}
                                    />
                                    <InputDate name='dataUltAcessoFinal'
                                      label={'Data Último Acesso - Final'}
                                      col={3}
                                    />
                                    <Col md={6}>
                                      <ButtonGroup style={{ marginTop: '15px' }}>
                                        <Button color="primary"
                                          onClick={() => { this.onSearch(values, handleSubmit, isValid) }}
                                        >
                                          <i className='fa fa-refresh' /> Atualizar</Button>
                                      </ButtonGroup>
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </Form>
                          )}
                        </Formik>
                      </Col>
                    </Row>
                  </CardHeader>

                  <div key={`tbl_${this.state.keyDatable}`}>
                    <TableReducer
                      reducer={contaAgrareReducer}
                      table={contaAgrareReducer.list}
                      renderActions={false}
                      filterNextPage={this.props.filterNextPage}
                      filter={contaAgrareReducer.filter}
                    >
                      <Column field='status' header='Ativo' body={renderColumnAtivo} style={{ textAlign: 'center' }} />

                      <Column field='licenca.licencaEmTeste' header='Em Teste' body={renderColumnIsTesting} style={{ textAlign: 'center' }} />

                      <Column field='accountCode' header='Código da Conta' style={{ minWidth: '200px' }} />

                      <Column field='nomeConta' header='Nome da Conta' body={renderNomeConta} style={{ minWidth: '200px' }} />

                      <Column field='atividadeAgricola' header='Atividade Agrícola' body={renderAtividadeAgricola} style={{ minWidth: '200px' }} />

                      <Column field='localTrabalho' header='Local de Trabalho' body={renderLocalTrabalho} style={{ minWidth: '200px' }} />

                      <Column field='nomeResponsavelConta' header='Nome Responsável' style={{ minWidth: '200px' }} />

                      <Column field='emailPrincipal' header='Email Responsável' style={{ minWidth: '200px' }} />

                      <Column field='licenca.dataCadastro' header='Data de Criação' body={renderColumnDataCadastro} style={{ minWidth: '150px' }} />

                      <Column field='nroProrrogacoesTeste' header='Nº Prorrog. de Teste' body={renderColumnNroProrrogacoesTeste} style={{ textAlign: 'center', minWidth: '100px' }} />

                      <Column field='licenca.dataFimPeriodoTeste' header='Data Fim do Teste' body={renderColumnDataFimPeriodoTeste} style={{ minWidth: '150px' }} />

                      <Column field='dataRenovacao' header='Data de Renovação' body={renderColumnDataRenovacao} style={{ minWidth: '150px' }} />

                      <Column field='dataUltimoAcesso' header='Data Ult. Acesso'  body={renderColumnDataUltimoAcesso} style={{ minWidth: '150px' }} />

                      <Column field='dataBloqueio' header='Data de Bloqueio' body={renderColumnDataBloqueio} style={{ minWidth: '150px' }} />

                      <Column field='objetivoProdutor' header='Desafio Produtor' body={renderColumnObjetivo}  style={{ minWidth: '200px' }} />

                      <Column field='comoConheceuAgrare' header='Como Nos Conheceu' body={renderColumnComoConheceu}  style={{ minWidth: '200px' }} />

                      {/* {(loginReducer.user.idPartnerWhiteLabel === undefined || loginReducer.user.idPartnerWhiteLabel === null) ? (
                        <Column field='partnerWhiteLabel.name' header='Parceiro' />
                      ) : null} */}

                      <Column style={{ textAlign: 'center', minWidth: '200px' }}
                        body={(rowData, column) => {
                          return (
                            <>
                              <ButtonDropdown 
                                isOpen={this.state.openDropdownId === rowData.id} 
                                toggle={() => this.toggleDropdown(rowData.id)}
                                style={{ marginRight: '5px' }}
                                direction="down"
                              >
                                <DropdownToggle caret color="dark" size="sm">
                                  Ações
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={() => this.toggleProrrogarTesteModal(rowData)}>
                                    Prorrogar Teste
                                  </DropdownItem>
                                  {rowData.licenca.bloqueado ? (
                                    <DropdownItem onClick={() => this.props.desbloquearContaAgrare(rowData.id)}>
                                      Desbloquear
                                    </DropdownItem>
                                  ) : (
                                    <DropdownItem onClick={() => this.props.bloquearContaAgrare(rowData.id)}>
                                      Bloquear
                                    </DropdownItem>
                                  )}
                                  <DropdownItem onClick={async () => {
                                    await this.props.findContaAgrare(rowData.id);
                                    this.props.history.push(`/corporate/contaProdutor/liberar/${rowData.id}`);
                                  }}>
                                    Liberar
                                  </DropdownItem>
                                </DropdownMenu>
                              </ButtonDropdown>

                              <Link to={`/corporate/contaProdutor/editar/${rowData.id}`}>
                                <Button
                                  outline
                                  color='white'
                                  className='btn btn-warning btn-sm'
                                  onClick={() => this.props.findContaAgrare(rowData.id)}
                                  style={{ marginRight: '5px' }}
                                >
                                  <i className='fas fa-pencil-alt' />
                                </Button>
                              </Link>

                              <Delete
                                disabled
                                registro={rowData}
                                remove={this.remove}
                                removed={contaAgrareReducer.removed}
                                indexFieldMsgDelete={-1}
                                msgDelete={`Deseja excluir a conta ${rowData.nomeConta}?`}
                              />

                              <Button
                                className="bn btn-primary btn-sm"
                                style={{ marginLeft: '5px' }}
                                onClick={async () => {
                                  const configSessionAtual = JSON.parse(storage.get(CONFIG_SESSION));
                                  await this.props.findContaAgrare(rowData.id);

                                  var configSession = {
                                    ...configSessionAtual,
                                    schemaSelecionado: rowData.nomeSchema,
                                    contaAgrare: this.props.contaAgrareReducer.registro
                                  }
                              
                                  await storage.set(CONFIG_SESSION, JSON.stringify(configSession));

                                  await this.props.listPropriedadeCadastro();

                                  this.props.selectFazenda(
                                    this.props.propriedadeCadastroReducer.table?.content[0]?.id,
                                    {
                                      ...this.props.contaAgrareReducer.registro,
                                      ...this.props.contaAgrareReducer.registro?.licenca
                                    }
                                  );
                                }}
                              >
                                <i className='fas fa-door-open' />
                              </Button>
                            </>
                          );
                        }} />
                    </TableReducer>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </HorizontalLayout>
    );
  }
}

export function mapStateToProps(state) {
  const { contaAgrareReducer, propriedadeCadastroReducer, loginReducer } = state.entities;
  return { contaAgrareReducer, propriedadeCadastroReducer, loginReducer };
};

function mapDispatchToProps(dispatch) {
  return {
    hasAuthorityCorporate: (role) => dispatch({ type: HAS_AUTHORITY_CORPORATE, role }),
    filter: (newFilter, args) => dispatch({ type: NEW_FILTER_CONTA_AGRARE, newFilter, args }),
    filterNextPage: (rows, page) => dispatch({ type: NEW_FILTER_NEXT_PAGE_CONTA_AGRARE, rows, page }),
    deleteContaAgrare: (id) => dispatch({ type: DELETE_CONTA_AGRARE, id }),
    bloquearContaAgrare: (id) => dispatch({ type: BLOQUEAR_CONTA_AGRARE, id }),
    desbloquearContaAgrare: (id) => dispatch({ type: DESBLOQUEAR_CONTA_AGRARE, id }),
    prorrogarTesteContaAgrare: (data) => dispatch({ type: PRORROGAR_TESTE_CONTA_AGRARE, data }),
    selectFazenda: (idFazenda, contaAgrare) => dispatch({ type: SELECT_FAZENDA, idFazenda, contaAgrare, refreshPage: false }),
    findContaAgrare: (id) => {
      return new Promise((resolve) => {
        dispatch({ type: FIND_CONTA_AGRARE, id, resolve });
      });
    },
    listPropriedadeCadastro: (args) => {
      return new Promise((resolve) => {
        dispatch({ type: TABLE_PROPRIEDADE_CADASTRO, args, resolve });
      });
    },
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ContaAgrare));
